import React from 'react';

import { CircularProgress, CircularProgressProps } from '@mui/material';

import useStyles from './styles';

interface Props extends CircularProgressProps {}

const CircularProgressOutlined: React.FC<Props> = ({ variant, color, value, className, ...restProps }) => {
    const { classes: internalClasses, cx } = useStyles();
    return (
        <div className={cx(internalClasses.root, className)}>
            <CircularProgress variant="determinate" value={100} className={internalClasses.outline} {...restProps} />
            <CircularProgress
                variant={variant}
                value={value}
                color={color}
                className={internalClasses.progress}
                {...restProps}
            />
        </div>
    );
};

export default CircularProgressOutlined;
